import React from "react";
import ConnectWallet from "../ConnectWallet";
const Header = ({ onHandleClick, open }) => {

  return (
    <>
      <header className={`${open ? "main-header nav-open" : "main-header"}`}>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="d-flex col-3 col-sm-3 order-2 order-sm-0 justify-content-end justify-content-sm-start">
              {/* onClick={onHandleCloseModal} */}
              <button
                className={
                  open
                    ? "nav-toggle btn btn-light nav-open"
                    : "nav-toggle btn btn-light"
                }
                // data-nav-toggle
                onClick={onHandleClick}
              >
                <div className="nav-toggle--overlay"></div>
                <div className="nav-toggle--hamburger"></div>
              </button>
            </div>
            <div className="main-header--logo col-3 col-sm-6 d-flex justify-content-sm-center">
              <a href="/">
                <svg
                  className="d-none d-sm-flex"
                  viewBox="0 0 168 15"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Dashboard-Copy"
                      transform="translate(-428.000000, -619.000000)"
                      fill="#FFFFFF"
                      fillRule="nonzero"
                    >
                      <g
                        id="Bang-&amp;-Olufsen---Logo"
                        transform="translate(428.000000, 619.300000)"
                      >
                        <path
                          d="M5.6,7 C7.3,6.6 8.4,5.6 8.3,3.7 C8.3,1.2 6.4,0.3 3.6,0.3 L0,0.3 L0,13.9 L3.6,13.9 C6.3,13.9 8.7,13.2 8.7,10.3 C8.7,8.4 7.4,7.2 5.6,7 Z M2.1,1.9 L4.1,1.9 C5.2,1.9 6.6,2.3 6.6,3.9 C6.6,5.9 5,6.1 3.1,6.1 L2.1,6.1 L2.1,1.9 Z M3.4,12.4 L2,12.4 L2,7.8 L3.2,7.8 C4.9,7.8 6.7,8.1 6.7,10.2 C6.7,12 5.1,12.4 3.4,12.4 Z"
                          id="Shape"
                        ></path>
                        <path
                          d="M17.5,2.1 L14.8,8.9 L20.2,8.9 L17.5,2.1 Z M16.6,0.3 L18.6,0.3 L24.3,14 L22.2,14 L20.8,10.6 L14.2,10.6 L12.8,14 L10.8,14 L16.6,0.3 Z"
                          id="Shape"
                        ></path>
                        <polygon
                          id="Path"
                          points="27.2 0.3 29.9 0.3 35.8 11.3 35.8 11.3 35.8 0.3 37.7 0.3 37.7 14 35.2 14 29.2 2.7 29.2 2.7 29.2 13.9 27.3 13.9"
                        ></polygon>
                        <path
                          d="M52.4,2.7 C51.5,2.1 50.4,1.8 48.7,1.8 C45.6,1.8 43.5,4.1 43.5,7.1 C43.5,10.3 45.8,12.4 48.6,12.4 C49.9,12.4 50.3,12.3 50.8,12.2 L50.8,8.1 L47.9,8.1 L47.9,6.5 L52.7,6.5 L52.7,13.6 C52,13.9 50.7,14.2 48.6,14.2 C44.3,14.2 41.5,11.4 41.5,7.1 C41.5,2.9 44.5,0.1 48.6,0.1 C50.6,0.1 51.4,0.4 52.6,0.8 L52.4,2.7 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M86.4,12.5 C89.5,12.5 90.8,9.9 90.8,7.2 C90.8,4.4 89.3,1.8 86.4,1.9 C83.4,1.9 82,4.5 82,7.2 C82,9.9 83.3,12.5 86.4,12.5 M86.4,0.1 C90.5,0.1 92.9,3.1 92.9,7.2 C92.9,11.4 90.5,14.3 86.4,14.3 C82.3,14.3 79.9,11.3 79.9,7.1 C79.9,3.1 82.3,0.1 86.4,0.1"
                          id="Shape"
                        ></path>
                        <polygon
                          id="Path"
                          points="96.7 0.3 98.6 0.3 98.6 12.2 104.2 12.2 104.2 13.9 96.6 13.9"
                        ></polygon>
                        <path
                          d="M117.3,8.3 C117.3,12.1 115.4,14.2 112.1,14.2 C108.8,14.2 106.9,12.1 106.9,8.3 L106.9,0.3 L108.8,0.3 L108.8,8.1 C108.8,10.7 109.6,12.5 112.1,12.5 C114.6,12.5 115.4,10.7 115.4,8.1 L115.4,0.3 L117.3,0.3 L117.3,8.3 L117.3,8.3 Z"
                          id="Path"
                        ></path>
                        <polygon
                          id="Path"
                          points="122 0.3 129.2 0.3 129.2 2 123.9 2 123.9 6 128.9 6 128.9 7.7 123.9 7.7 123.9 13.9 122 13.9"
                        ></polygon>
                        <path
                          d="M139.9,2.4 C138.9,2 138.4,1.8 137.4,1.8 C136.3,1.8 135,2.2 135,3.6 C135,6.2 140.8,5.6 140.8,10.1 C140.8,13 138.6,14.2 135.9,14.2 C135,14.2 134,13.9 133.1,13.6 L133.3,11.8 C134,12.1 135.1,12.5 136.1,12.5 C137.2,12.5 138.7,11.9 138.7,10.3 C138.7,7.2 132.9,8.1 132.9,3.8 C132.9,1.4 134.8,0.1 137.2,0.1 C138.1,0.1 139.2,0.3 140.1,0.6 L139.9,2.4 Z"
                          id="Path"
                        ></path>
                        <polygon
                          id="Path"
                          points="145.2 0.3 152.8 0.3 152.8 2 147.2 2 147.2 6 152.3 6 152.3 7.7 147.2 7.7 147.2 12.2 152.8 12.2 152.8 13.9 145.2 13.9"
                        ></polygon>
                        <polygon
                          id="Path"
                          points="157.2 0.3 159.8 0.3 165.7 11.3 165.7 11.3 165.7 0.3 167.6 0.3 167.6 14 165.1 14 159 2.8 159 2.8 159 14 157.1 14 157.1 0.3"
                        ></polygon>
                        <path
                          d="M71.4,10.5 L72.8,9.1 L71.4,7.7 L70,9.1 C70,9.1 66.2,5.2 65.5,4.5 C65.5,4.4 65.1,4.1 65.1,3.5 C65.1,2.6 65.9,2 66.5,2 C67,2 67.4,2.3 67.5,2.4 C67.7,2.2 68.8,1.1 68.9,1 C68.8,0.9 68,0 66.5,0 C64.5,0 63.1,1.7 63.1,3.4 C63.1,5.1 64.3,6 64.5,6.2 C64.3,6.6 63.8,7.1 63.4,7.6 C62.3,8.7 61.6,11.3 63.4,13.1 C65.2,14.9 67.7,14.3 68.8,13.1 C69.4,12.5 69.7,12.2 70,11.9 L71.9,13.8 L73.2,12.4 L71.4,10.5 Z M67.4,11.7 C66.7,12.4 65.5,12.6 64.7,11.7 C63.9,10.8 64,9.6 64.7,8.9 L65.9,7.7 L68.6,10.4 C68.7,10.5 68.1,11.1 67.4,11.7 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <svg
                  className="d-flex d-sm-none"
                  viewBox="0 0 57 60"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Artboard"
                      transform="translate(-671.000000, -187.000000)"
                      fill="#000000"
                    >
                      <g
                        id="Ofte-stillede-spørgsmål-om-forbundne-højttalere-–-B&amp;O-7"
                        transform="translate(671.000000, 187.000000)"
                      >
                        <path
                          d="M32.291395,17.4522 C32.291395,19.1723 32.969995,20.7546 34.251895,22.0313 C36.054795,23.8237 38.029295,24.0686 39.372595,23.9611 C40.970695,23.8307 42.578095,23.1038 43.675895,22.0147 L43.957095,21.7346 C44.763795,20.931 45.258395,20.4383 45.740195,19.9731 L49.050195,23.1838 L51.374295,20.8599 L51.405795,20.8026 L48.144695,17.5532 L50.464195,15.2408 L48.039395,12.8259 L45.719595,15.1406 C45.719595,15.1406 38.940995,8.37288 38.099995,7.52677 C37.648195,7.06986 37.371195,6.58897 37.371195,5.82527 C37.371195,5.01591 37.737895,4.47583 38.049895,4.16748 C38.503195,3.71445 39.170995,3.4328 39.781995,3.4328 C40.713895,3.4328 41.288795,3.92452 41.485395,4.13305 L41.535895,4.18334 L41.586395,4.13537 L42.964195,2.76775 L43.915195,1.82066 L43.955995,1.77308 L43.891495,1.7015 C43.267995,1.06624 41.897895,0 39.773795,0 C38.155095,0 36.656095,0.642996 35.557095,1.80906 C34.527295,2.89813 33.939995,4.35744 33.939995,5.81405 C33.939995,8.23322 35.322495,9.72 36.300295,10.6253 L34.237495,12.6359 C33.037595,13.8294 32.291395,15.6776 32.291395,17.4522 Z M36.670495,15.0644 L38.718795,13.0228 L43.304095,17.5462 C43.094795,17.7609 42.206695,18.6535 41.228995,19.6187 C40.048095,20.7751 38.092195,21.0181 36.670495,19.6044 C36.050095,18.9827 35.722595,18.212 35.722595,17.3698 C35.722595,16.5214 36.078395,15.6571 36.670495,15.0644 Z M51.614695,31.8444 C48.480795,28.7343 44.311295,27.0231 39.877695,27.0231 C35.444495,27.0231 31.274495,28.7343 28.139895,31.8444 C25.005995,34.9576 23.279395,39.0915 23.279395,43.4897 C23.279395,47.8886 25.005995,52.0199 28.139895,55.13 C31.274495,58.242 35.444495,59.9535 39.877695,59.9535 C44.311295,59.9535 48.480795,58.242 51.614695,55.13 C54.750095,52.0199 56.477495,47.8886 56.477495,43.4897 C56.477495,39.0915 54.750095,34.9576 51.614695,31.8444 Z M39.877695,55.7176 C36.584095,55.7176 33.486895,54.4442 31.159195,52.1346 C28.830495,49.8254 27.543995,46.7532 27.543995,43.4897 C27.543995,40.2196 28.830495,37.1501 31.159195,34.8409 C33.486895,32.5271 36.584095,31.2556 39.877695,31.2556 C43.171195,31.2556 46.267295,32.5271 48.597695,34.8409 C50.923295,37.1501 52.208295,40.2196 52.208295,43.4897 C52.208295,50.2315 46.677895,55.7176 39.877695,55.7176 Z M23.306195,19.7394 C23.306195,26.7462 19.442795,33.1364 13.211595,36.4393 C14.991595,37.5605 16.489995,39.1086 17.526795,40.9294 C18.622495,42.8384 19.202495,45.015 19.202495,47.2234 C19.202495,50.6333 17.858295,53.8423 15.424395,56.2585 C12.995495,58.6705 9.757995,59.9999 6.317595,59.9999 L0.009348,59.9999 L7.77156117e-16,0.814872 L4.232245,0.814872 C9.326795,0.814872 14.118795,2.78216 17.724695,6.36051 C21.329895,9.93501 23.306195,14.6875 23.306195,19.7394 Z M14.703795,9.35278 C11.922395,6.59541 8.221835,5.07011 4.292225,5.05195 L4.292225,34.4291 C8.221835,34.4109 11.922395,32.8853 14.703795,30.129 C17.503895,27.3562 19.036895,23.6654 19.036895,19.7394 C19.036895,15.8179 17.503895,12.1299 14.703795,9.35278 Z M4.292225,55.7652 L6.312915,55.7652 C11.061195,55.7652 14.924595,51.9334 14.924595,47.2234 C14.924595,44.9412 14.031095,42.7978 12.405795,41.1805 C10.777695,39.5698 8.597695,38.6843 6.295005,38.6843 C6.295005,38.6843 4.641985,38.6751 4.292225,38.6751 L4.292225,55.7652 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
            <div className="col-6 col-sm-3 d-flex justify-content-center justify-content-sm-end">
              <ConnectWallet />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
